import React from 'react';

const TargetAudienceSection = () => {
  return (
    <section className="target-audience-section">
      <div className="audience-content">
        <h2 className="section-title">Who Is This For</h2>
        <div className="title-underline"></div>
        
        <p className="section-description">
          Whether you're aiming for your first cloud job or looking to level up your tech career, this program is for
        </p>
        
        <div className="audience-cards">
          <div className="audience-card it-professionals">
            <h3>Working IT professionals</h3>
            <p>Looking to shift into cloud or Devops roles</p>
          </div>
          
          <div className="audience-card testers-developers">
            <h3>Manual testers & developers</h3>
            <p>Wanting to master automation and Devops tools</p>
          </div>
          
          <div className="audience-card freshers">
            <h3>Freshers with a tech background</h3>
            <p>seeking better job opportunities</p>
          </div>
        </div>
      </div>
    </section>
  );
};

export default TargetAudienceSection; 